import React, { useState } from "react";
import PropTypes from "prop-types";
import DropdownHeader from "./DropdownHeader";
import DropdownValue from "./DropdownValue";
import DropdownOptionsList from "./DropdownOptionsList";
import ArrowButtons from "./ArrowButtons";
import "./Dropdown.css";

const Dropdown = ({
  title,
  value,
  options,
  handleSelectOption,
  incrementor
}) => {
  const [active, setActive] = useState(false);

  const updateOption = (value) => {
    handleSelectOption(value);
  };

  const handleClick = () => {
    setActive(!active);
  };

  const closeDropdown = () => {
    setActive(false);
  };

  const selectOption = (value) => {
    updateOption(value);
    handleClick();
  };

  return (
    <div className={`dropdown ${active ? "active" : "inactive"}`}>
      <DropdownHeader title={title} active={active} />

      <DropdownValue value={value} handleClick={handleClick} />

      {incrementor && (
        <ArrowButtons
          value={value}
          options={options}
          updateOption={updateOption}
        />
      )}

      {active && (
        <DropdownOptionsList
          value={value}
          options={options}
          handleClick={handleClick}
          selectOption={selectOption}
          closeDropdown={closeDropdown}
        />
      )}
    </div>
  );
};

Dropdown.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array.isRequired,
  handleSelectOption: PropTypes.func.isRequired,
  incrementor: PropTypes.bool
};

export default Dropdown;
